<template>
  <div class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
    <div class="flex-1 min-w-0">
      <a v-on:click="checkConfirmation" class="focus:outline-none">
        <div class ="px-1 flex items-center justify-between">
          <p class="xl:text-xl 2xl:text-sm font-medium text-gray-900">
            {{ title }}
          </p>
          <span v-if="badge_label !== ''" class="items-center flex-shrink-0 flex rounded-full bg-red-500 px-2 py-1 text-xs font-medium text-white">
            {{ badge_label }}
          </span>
        </div>
      </a>
    </div>
  </div>

</template>

<script>
export default {
  name: 'home-button',
  props: {
    title: {
      type: String,
      required: true
    },
    blueprintid: {
      type: null,
      required: true
    },
    validate:{
      type: Boolean,
      default: false
    },
    badge: {
      type: String,
      default: '',
      required: false
    }
  },
  mounted: function () {
    this.getBadge()
  },
  methods: {
    async checkConfirmation(){
      if (this.validate === true){
        let config = {
          params: {
              ...this.$store.state.data,
          }
        }
        const response = await this.$http.get(`validation?funcname=prevalidation&blueprintid=${this.blueprintid}`, config)
        if (response.data.data !== undefined && response.data.data.store !== undefined) {
          this.$store.commit('setState', response.data.data.store)
        }
        let recordid = 0
        let blueprint = this.blueprintid
        if (response.data.data !== undefined && response.data.data.recordid !== undefined){
          recordid = response.data.data.recordid
        }
        if (response.data.data !== undefined && response.data.data.blueprintid !== undefined){
          blueprint = response.data.data.blueprintid
        }
        if (response.data.result === 'error'){
          console.log("error");
        } else {
          this.$router.push('/form/' + blueprint + "/" + recordid)
        }
      } else {
        this.$router.push('/form/' + this.blueprintid + "/0")
      }
      this.$router.go()
    },
    async getBadge(){
      let config = {
        params: {
          blueprintid: this.blueprintid,
          ...this.$store.state.data
        }
      }
      if (this.badge === ''){
        return
      }
      const response = await this.$http.get(this.badge, config)
      this.badge_label = response.data
    }
  },
  data() {
    return {
      badge_label: ''
    }
  }
}
</script>
